import React, { useEffect, useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/benefisCategory/benefisCategoryAction";
import * as uiHelpers from "../BenefisCategoryUIHelpers";

import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
} from "../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../_metronic/_partials/controls";
import { useBenefisCategoryUIContext } from "../BenefisCategoryUIContext";
import { RoleChecker } from "../../../../RoleChecker";
// import { ToastContainer } from 'react-toastify';

const BenefisCategoryTable = (props) => {
  // BenefisCategory UI Context
  const benefisCategoryUIContext = useBenefisCategoryUIContext();
  const benefisCategoryUIProps = useMemo(() => {
    return {
      queryParams: benefisCategoryUIContext.queryParams,
      setQueryParams: benefisCategoryUIContext.setQueryParams,
      openEditBenefisCategoryPage:
        benefisCategoryUIContext.openEditBenefisCategoryPage,
      openDeleteBenefisCategoryPage:
        benefisCategoryUIContext.openDeleteBenefisCategoryPage,
    };
  }, [benefisCategoryUIContext]);

  // Getting curret state of benefisCategory list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.benefisCategory }),
    shallowEqual
  );

  const { totalCount, entities, listLoading } = currentState;

  const dispatch = useDispatch();
  useEffect(() => {
    //Requset ke Branch Action
    dispatch(actions.fetchBenefisCategorys(benefisCategoryUIProps.queryParams));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [benefisCategoryUIProps.queryParams, dispatch]);

  const allowEdit = RoleChecker("Edit", "benefis_category");

  // Table columns
  const columns = [
    {
      dataField: "name",
      text: "Name",
      sort: true,
      // sortCaret: sortCaret,
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openEditBenefisCategoryPage:
          benefisCategoryUIProps.openEditBenefisCategoryPage,
        openDeleteBenefisCategoryPage:
          benefisCategoryUIProps.openDeleteBenefisCategoryPage,
        allowEdit,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
    },
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: benefisCategoryUIProps.queryParams.pageSize,
    page: benefisCategoryUIProps.queryParams.pageNumber,
  };

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="uuid"
                data={entities === null ? [] : entities}
                columns={columns}
                // defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  benefisCategoryUIProps.setQueryParams
                )}
                // selectRow={getSelectRow({
                //   entities,
                //   ids: productsUIProps.ids,
                //   setIds: productsUIProps.setIds,
                // })}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
};

export default BenefisCategoryTable;
